// Import
import $ from 'jquery';
import select2 from 'select2';
// Hook up select2 to jQuery
select2($);

const initSpreadsheetPeopleFilter = () => {
  // Initialize Select2 for the people filter multi-select
  const $peopleSelect = $('#people_filter_select');
  
  if ($peopleSelect.length && typeof $ !== 'undefined' && $.fn.select2) {
    // Destroy existing Select2 if any
    if ($peopleSelect.hasClass('select2-hidden-accessible')) {
      try {
        $peopleSelect.select2('destroy');
      } catch (e) {
        // Ignore
      }
    }
    
    // Wait a bit to ensure select2 is loaded
    setTimeout(function() {
      $peopleSelect.select2({
        theme: 'bootstrap-5',
        width: '100%',
        placeholder: 'Sélectionner des personnes...',
        allowClear: true,
        language: {
          noResults: function() {
            return "Aucun résultat trouvé";
          },
          searching: function() {
            return "Recherche en cours...";
          }
        }
      });
      
      // No auto-submit - user must click "Appliquer les filtres" button
    }, 200);
  }
};

export { initSpreadsheetPeopleFilter };

